// Modali dei dettagli (b-modal size="xl"): l'altezza segue il contenuto ma
// non scende mai, come le righe delle tabelle (calibrateRows in
// tables/template.vue). Cambiando scheda la modale resta alta quanto la
// scheda più alta vista finora, entro lo schermo; chiudendola si riparte.

// Lo stesso limite di .modal-content in custom.scss: un min-height oltre il
// max-height prevarrebbe e la modale uscirebbe dallo schermo.
const MAX_HEIGHT = "calc(100dvh - 1.75rem - 1.75rem)";

/**
 * Ascolta apertura e chiusura delle modali su $root.
 * @param {Vue} root
 * @returns {Function} toglie gli ascoltatori
 */
export const keepModalHeight = (root) => {
  // Per istanza, non per id: due modali aperte una sopra l'altra possono
  // avere lo stesso id (infomodalName vale "modal" di default).
  const observers = new Map();

  const onShown = (bvEvent) => {
    const modal = bvEvent.vueTarget;
    const content = modal?.$refs.content;
    const body = modal?.$refs.body;
    if (!body || !content?.closest(".modal-xl") || !window.ResizeObserver) {
      return;
    }
    let max = 0;
    let frame = null;
    const fit = () => {
      frame = null;
      // Altezza che la modale avrebbe senza limite: le parti fisse più
      // tutto il contenuto del corpo, anche quello che ora scorre.
      const natural =
        content.offsetHeight - body.clientHeight + body.scrollHeight;
      if (natural <= max) return;
      max = natural;
      content.style.minHeight = `min(${max}px, ${MAX_HEIGHT})`;
    };
    // Il corpo stesso, non i suoi figli: il contenuto può arrivare dopo
    // l'apertura (componenti asincroni, v-if sulla radice).
    const observer = new ResizeObserver(() => {
      if (!frame) frame = requestAnimationFrame(fit);
    });
    observer.observe(body);
    observers.set(modal, {
      observer,
      content,
      cancel: () => cancelAnimationFrame(frame),
    });
    // Una modale distrutta mentre è aperta (cambio di pagina, v-if) non
    // emette hidden: senza questo l'osservatore resterebbe in memoria.
    modal.$once("hook:beforeDestroy", () => onHidden({ vueTarget: modal }));
    fit();
  };

  const onHidden = (bvEvent) => {
    const entry = observers.get(bvEvent.vueTarget);
    if (!entry) return;
    entry.cancel();
    entry.observer.disconnect();
    entry.content.style.minHeight = "";
    observers.delete(bvEvent.vueTarget);
  };

  root.$on("bv::modal::shown", onShown);
  root.$on("bv::modal::hidden", onHidden);
  return () => {
    root.$off("bv::modal::shown", onShown);
    root.$off("bv::modal::hidden", onHidden);
    [...observers.keys()].forEach((modal) => onHidden({ vueTarget: modal }));
  };
};
